import { Mail, Bell } from 'lucide-react';

const Toggle = ({ active, onClick, icon: Icon, label, testid }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={active}
    className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200"
    style={{
      fontFamily: 'Manrope, sans-serif',
      backgroundColor: active ? '#E57A44' : '#FFFFFF',
      color: active ? '#FDFBF7' : '#595553',
      border: `1px solid ${active ? '#E57A44' : '#E6E2D8'}`,
    }}
    data-testid={testid}
  >
    <Icon className="w-4 h-4" /> {label}
  </button>
);

export const ChannelToggles = ({ channels, onChange, testidPrefix = 'channel' }) => (
  <div data-testid={`${testidPrefix}-toggles`}>
    <p className="text-xs font-bold uppercase tracking-wider mb-2" style={{ fontFamily: 'Manrope, sans-serif', color: '#8C867D' }}>Send via</p>
    <div className="flex flex-wrap gap-2">
      <Toggle active={channels.send_email} onClick={() => onChange({ ...channels, send_email: !channels.send_email })} icon={Mail} label="Email" testid={`${testidPrefix}-email-toggle`} />
      <Toggle active={channels.send_push} onClick={() => onChange({ ...channels, send_push: !channels.send_push })} icon={Bell} label="Push notification" testid={`${testidPrefix}-push-toggle`} />
    </div>
    {!channels.send_email && !channels.send_push && (
      <p className="text-xs mt-2" style={{ fontFamily: 'Manrope, sans-serif', color: '#B8564A' }} data-testid={`${testidPrefix}-none-warning`}>Choose at least one channel.</p>
    )}
  </div>
);

export const describePushResult = (push) => (push ? ` · Push: ${push.sent}/${push.total} devices` : '');
